import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { SPAViewContext } from '@confluence/spa-view-context';

import { ChangeEditionSectionMessage } from './ChangeEditionSectionMessage';

const i18n = defineMessages({
	siteAdminSpacePermissionsTitle: {
		id: 'change-edition.section.message.site-admin.space-permissions.title',
		defaultMessage: 'Upgrade for space permissions',
		description: 'Upgrade for space permissions title for site admins',
	},
	nonSiteAdminSpacePermissionsTitle: {
		id: 'change-edition.section.message.non-admin.space-permissions.title',
		defaultMessage: 'Space permissions are only available on paid plans',
		description: 'Space permissions title for non-site admins',
	},
	siteAdminSpaceBody: {
		id: 'change-edition.section.message.site-admin-space.body',
		defaultMessage:
			'You’re on the free plan, so you can’t set the default permissions for new spaces. Anyone who’s logged in can view new spaces, add pages to them, and more. To set default space permissions, upgrade your plan.',
		description: 'Warning message explaining why the form is not editable for site admins',
	},
	nonSiteAdminSpaceBody: {
		id: 'change-edition.section.message.non-admin-space.body',
		defaultMessage:
			'You’re on the free plan, so you can’t set the default permissions for new spaces. Anyone who’s logged in can view new spaces, add pages to them, and more.',
		description: 'Warning message explaining why the form is not editable for non-site admins',
	},
});

export const ChangeEditionSectionMessageAdminSpace = () => {
	const { formatMessage } = useIntl();
	const { isSiteAdmin } = useContext(SPAViewContext);
	const title = isSiteAdmin
		? i18n.siteAdminSpacePermissionsTitle
		: i18n.nonSiteAdminSpacePermissionsTitle;
	const body = isSiteAdmin ? i18n.siteAdminSpaceBody : i18n.nonSiteAdminSpaceBody;

	return (
		<ChangeEditionSectionMessage
			title={formatMessage(title)}
			body={formatMessage(body)}
			source="adminSpacePermissions"
		/>
	);
};
